import { LocationConfig } from '../Types/Config'

export const WHITELIST_LOCATIONS = [
  {
    lat: 51.5285582,
    lon: -0.2416795,
    name: 'London',
    radiusKM: 30,
  },
  {
    lat: 53.326318,
    lon: -6.2458992,
    name: 'Dublin',
    radiusKM: 5,
  },
  {
    lat: 40.75123,
    lon: -73.98637,
    name: 'New York',
    radiusKM: 2.01168,
  },
  {
    lat: 53.477422,
    lon: -2.243958,
    name: 'Manchester',
    radiusKM: 20,
  },
  {
    lat: 52.481845,
    lon: -1.895506,
    name: 'Birmingham',
    radiusKM: 5,
  },
  {
    name: 'Edinburgh',
    lat: 55.95196,
    lon: -3.18994,
    radiusKM: 8,
  },
  {
    lat: 51.454514,
    lon: -2.58791,
    name: 'Bristol & Bath',
    radiusKM: 30,
  },
  {
    lat: -32.0397559,
    lon: 115.6813531,
    name: 'Perth WA',
    radiusKM: 30,
  },
  {
    lat: -27.4727591,
    lon: 152.9912678,
    name: 'Brisbane',
    radiusKM: 30,
  },
  {
    lat: -27.9666859,
    lon: 153.3434263,
    name: 'Gold Coast',
    radiusKM: 20,
  },
  {
    lat: -33.86882,
    lon: 151.20929,
    name: 'Sydney',
    radiusKM: 30,
  },
  {
    lat: -37.8136,
    lon: 144.9631,
    name: 'Melbourne',
    radiusKM: 30,
  },
  {
    lat: -34.9070228,
    lon: 138.6811677,
    name: 'Adelaide',
    radiusKM: 30,
  },
  {
    lat: -35.335065,
    lon: 149.1865452,
    name: 'Canberra',
    radiusKM: 30,
  },
  {
    lat: 40.720239,
    lon: -74.000657,
    name: 'Lower Manhattan',
    radiusKM: 2.119,
  },
  {
    lat: 40.734174,
    lon: -74.004752,
    name: 'West Village',
    radiusKM: 1.246,
  },
  {
    lat: 40.709638,
    lon: -74.011285,
    name: 'Fi Di',
    radiusKM: 1.235,
  },
  {
    name: 'Glasgow',
    lat: 55.8607819,
    lon: -4.2586295,
    radiusKM: 5.0,
  },
  {
    lat: 40.686841,
    lon: -73.959184,
    name: 'Brooklyn',
    radiusKM: 5.89898,
  },
  {
    lat: -36.8485,
    lon: 174.7633,
    name: 'Auckland',
    radiusKM: 30,
  },
] as const satisfies LocationConfig[]

export const AU_CITIES_LOCATIONS = [
  {
    name: 'Brisbane',
    lat: -27.4727591,
    lon: 152.9912678,
    radiusKM: 30,
  },
  {
    name: 'Sydney',
    lat: -33.86882,
    lon: 151.20929,
    radiusKM: 30,
  },
  {
    name: 'Melbourne',
    lat: -37.8136,
    lon: 144.9631,
    radiusKM: 30,
  },
  {
    name: 'Perth',
    lat: -31.9523,
    lon: 115.8613,
    radiusKM: 30,
  },
  {
    name: 'Adelaide',
    lat: -34.9285,
    lon: 138.6007,
    radiusKM: 30,
  },
  {
    name: 'Gold Coast',
    lat: -27.9666859,
    lon: 153.3434263,
    radiusKM: 20,
  },
  {
    name: 'Newcastle',
    lat: -32.9283,
    lon: 151.7817,
    radiusKM: 30,
  },
  {
    name: 'Canberra',
    lat: -35.2809,
    lon: 149.13,
    radiusKM: 30,
  },
  {
    name: 'Sunshine Coast',
    lat: -26.65,
    lon: 153.0667,
    radiusKM: 30,
  },
  {
    name: 'Wollongong',
    lat: -34.4248,
    lon: 150.8931,
    radiusKM: 30,
  },
] as const satisfies LocationConfig[]
